import { parseISO } from 'date-fns';

/**
 * True iff a manual-verification lock window is currently active. Lock is
 * derived from `lock_expires_at` — the BE doesn't auto-clear the timestamp
 * on expiry, so the FE compares against `now` on every render. Returns
 * false for null, missing, or malformed timestamps.
 */
export function isLockActive(
  lockExpiresAt: string | null | undefined,
): boolean {
  if (!lockExpiresAt) return false;
  const when = parseISO(lockExpiresAt);
  if (Number.isNaN(when.getTime())) return false;
  return when > new Date();
}
